import {
  SpecialRequestCommentState,
  UpdateSpecialRequestCommentArgs,
  useUserContextSelector,
} from '@/redux';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormSpecialRequestComment } from './FormSpecialRequestComment';
import { Comment } from 'antd';
import { DateTimeValue, DeleteIconButton, EditIconButton } from '@/components';
import styles from './SpecialRequestCommentsPanel.module.scss';

interface Props {
  value: SpecialRequestCommentState;
  onDelete: (id: string) => any;
  onSubmit: (value: UpdateSpecialRequestCommentArgs) => any;
  readonly?: boolean;
}

export function SpecialRequestCommentItem(props: Props) {
  const { value, onDelete, onSubmit, readonly } = props;

  const { t } = useTranslation();

  const [isEdit, setEdit] = useState(false);

  const userId = useUserContextSelector((x) => x.id);

  const handleSubmit = (value: UpdateSpecialRequestCommentArgs) => {
    onSubmit(value);
    setEdit(false);
  };

  return (
    <div className="mb-1">
      {isEdit ? (
        <FormSpecialRequestComment<UpdateSpecialRequestCommentArgs>
          value={value}
          onSubmit={handleSubmit}
          onCancel={() => setEdit(false)}
        />
      ) : (
        <Comment
          content={<div className="text-multiline">{value.content}</div>}
          author={value.createdByName}
          datetime={
            <>
              <DateTimeValue value={value.createdAt} />
              {userId === value.createdById && !readonly && (
                <span className={styles.actionIcons}>
                  <EditIconButton type="link" onClick={() => setEdit(true)} />
                  <DeleteIconButton
                    confirm
                    entityName={t('tasks.comments.entityName')}
                    type="link"
                    onClick={() => onDelete(value.id)}
                  />
                </span>
              )}
            </>
          }
        />
      )}
    </div>
  );
}
